/* THIS FILE WAS AUTO-GENERATED. DO NOT MODIFY */
/* eslint-disable */
import * as SchemaTypes from '../../../../types/graph';

import * as Operations from './mutation.graphql';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type SaveEmailMutationVariables = SchemaTypes.Exact<{
  input: SchemaTypes.IdentityProfileUpdateMutationInput;
}>;


export type SaveEmailMutation = { __typename?: 'Mutation', customers: { __typename?: 'CustomersMutation', identity_profile_update: { __typename?: 'IdentityProfile', id: string, email: string | null } | null } };


export function useSaveEmailMutation(baseOptions?: Apollo.MutationHookOptions<SaveEmailMutation, SaveEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveEmailMutation, SaveEmailMutationVariables>(Operations.SaveEmail, options);
      }
export type SaveEmailMutationHookResult = ReturnType<typeof useSaveEmailMutation>;